import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import { useEventList } from '~/features/event-info/queries/event-info'
import Search from '~/shared/assets/icons/Search'
import theme from '~/shared/styles/theme'

function EventInfoCircleSearch() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchWord, setSearchWord] = useState<string>(
    searchParams.get('search') || '',
  )

  const { data: eventList } = useEventList()

  const searchCircle = () => {
    searchParams.set('search', searchWord)
    setSearchParams(searchParams)
  }

  return (
    <>
      {eventList && (
        <Wrapper>
          <InputBox>
            <Input
              placeholder="서클명을 입력하세요."
              defaultValue={searchWord}
              onChange={(e) => {
                setSearchWord(e.target.value)
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  searchCircle()
                }
              }}
            />
            <SearchIcon
              onClick={() => {
                searchCircle()
              }}
            />
          </InputBox>
        </Wrapper>
      )}
    </>
  )
}

export default EventInfoCircleSearch

const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  width: 100%;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`

const InputBox = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;

  /* width: 100%; */
  height: 65px;

  border-bottom: 2px solid ${theme.colors.grey_5};
`

const Input = styled.input`
  width: 900px;
  height: 90%;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;

  background-color: transparent;
  border: none;
  outline: none;

  @media ${theme.device.medium} {
    font-size: 21px;
  }
`

const SearchIcon = styled(Search)`
  cursor: pointer;
`
